import { ConditionalRendering } from "@marketplace/ui";
import clsx from "clsx";

import { useAuth } from "@/modules/auth";

import classes from "./header.module.css";
import { UserInfo } from "./user-info";

export const Header = () => {
  const { userData, isAuthenticated } = useAuth();

  return (
    <header className={clsx(classes.header)}>
      <ConditionalRendering condition={isAuthenticated}>
        <UserInfo userData={userData} />
      </ConditionalRendering>
    </header>
  );
};
